import { injectIntl } from 'react-intl';
import RequestId from './RequestId';
import config from './config';

export const CONFIG = config;

export default injectIntl(RequestId);
